import $ from 'jquery'
import Splide from '@splidejs/splide'
import {algoliaApiKey, algoliaAppId, locationSearchIndex} from '../variables';
import algoliasearch from 'algoliasearch/lite';
import {autocomplete, getAlgoliaResults} from '@algolia/autocomplete-js';
import '@algolia/autocomplete-theme-classic';
import {createCookie, readCookie} from "../global";
import {placesSearch} from "../pages/places";
import {Alert} from "../functions";

const { __ } = wp.i18n
const object = vnObject

var blockSearchForm = $('.js-search-block');
$('.js-search-block-submit').on('click', function () {
    blockSearchForm.trigger('submit')
})

blockSearchForm.on('submit', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const formData = new FormData(blockSearchForm[0])
    formData.append('action', 'vn_search_place')
    formData.append('nonce', object.nonce)

    const $form = $(this)
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        data: formData,
        beforeSend: () => {
            $form.addClass('sending')
        },
        processData: false,
        contentType: false,
        success: (res) => {
            $form.removeClass('sending')

            if (res.success && res.data.redirect) {
                window.location = res.data.redirect
            }
        },
    })
})

const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)
let blockSearch

const check = $('.block-search-handler')
const checkEl = document.querySelector('.block-search-handler')
if ( checkEl ) {
    blockSearch = autocomplete({
        container: '.block-search-handler',
        detachedMediaQuery: 'none',
        placeholder: __('Your location...', 'vn'),
        getSources() {
            return [
                {
                    // Set source of the autocomplete datas
                    sourceId: 'myLocation',
                    getItems({ query }) {
                        var cookieLatLng = readCookie('lat_lng')

                        var latitude = null;
                        var longitude = null;

                        if ( cookieLatLng != null ) {
                            var parts = cookieLatLng.split(',');

                            latitude = parseFloat(parts[0]);
                            longitude = parseFloat(parts[1]);
                        }
                        return [
                            { title: __('Near', 'vn'), lat: latitude, lng: longitude },
                        ]
                    },
                    // Set template of the autocomplete datas
                    templates: {
                        item({ item }) {
                            return `${item.title}`;
                        },
                    },
                    // On select, change the value of current location
                    onSelect: function (event) {
                        var latitude = event.item.lat;
                        var longitude = event.item.lng;

                        if ( latitude == null || event.item.lng == null ) {
                            navigator.geolocation.getCurrentPosition(
                                function(position) {
                                    latitude = position.coords.latitude;
                                    longitude = position.coords.longitude;

                                    createCookie('lat_lng', latitude + ', ' + longitude, '10');

                                    event.setQuery(event.item.title);
                                    $('.js-city').val( event.item.title )
                                    let latLng = parseFloat(latitude) + ',' + parseFloat(longitude);

                                    if ( latLng ) {
                                        $('.js-latlng').val( latLng )
                                    }
                                },
                                function(error) {
                                    Alert('warning', __('Geolocation is disabled. Please enable it in your browser settings.', 'vn'), false)
                                }
                            );
                        }
                        else {
                            event.setQuery(event.item.title);
                            $('.js-city').val( event.item.title )
                            let latLng = parseFloat(latitude) + ',' + parseFloat(longitude);

                            if ( latLng ) {
                                $('.js-latlng').val( latLng )
                            }
                        }
                    },
                },
                {
                sourceId: 'locations',
                getItems({ query }) {
                    return getAlgoliaResults({
                        searchClient,
                        queries: [
                            {
                                indexName: locationSearchIndex,
                                query,
                            },
                        ],
                    });
                },
                templates: {
                    item({ item }) {
                        return `${item.title}`;
                    },
                },
                onSelect: function (event) {
                    event.setQuery( event.item.title );
                    $('.js-city').val( event.item.title )
                    let latLng = event.item._geoloc;
                    if ( latLng ) {
                        $('.js-latlng').val( parseFloat(latLng.lat) + ',' + parseFloat(latLng.lng) )
                    }
                },
            }];
        },
    });

    console.log(check.data('near'))
    if ( check.data('near') ) {
        blockSearch.setQuery( __('Near', 'vn') );
    }
}